import { z } from 'zod';
import type { LateInterestStatus } from '../enums.js';

/**
 * Intérêts de retard dus sur une facture : la créance que fixe la dernière relance envoyée.
 * Ce que la relance a réclamé reste sur la relance ; ce qui a été reçu est sur le registre des
 * paiements ; ceci dit ce qui reste dû, et si le cabinet l'a abandonné.
 */

export const lateInterestParamSchema = z.object({ id: z.uuid(), interestId: z.uuid() }).strict();

export interface LateInterestDto {
  id: string;
  invoiceId: string;
  dunningNoticeId: string;
  /** Niveau de la relance qui a fixé la créance. */
  level: number;
  amountCents: number;
  paidCents: number;
  /** Encore dû : `amountCents − paidCents` tant que la créance est ouverte, zéro sinon. */
  dueCents: number;
  status: LateInterestStatus;
  replacedAt: string | null;
  waivedAt: string | null;
  waivedBy: string | null;
  createdAt: string;
}
